import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { RestangularModule, Restangular } from "ngx-restangular";


@Injectable()
export class ExamService {
  private apiUrl = "/api/v1";
  private baseUrlNew = "https://qhsebe.ilooopsqhse.com/api/v1";


  constructor(private http: HttpClient, private restangular: Restangular) {}

  // Add a new assessment with Authorization header
  addExam(assessmentData: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.post(`${this.baseUrlNew}/temp-exams`, assessmentData, {
      headers,
    });
  }

  // Update an existing assessment by ID with Authorization header
  updateExam(id: number, assessmentData: any): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.put(`${this.apiUrl}/temp-exams/${id}`, assessmentData, {
      headers,
    });
  }

  // Delete an assessment by ID with Authorization header
  deleteExam(id: number): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.delete(`${this.apiUrl}/temp-exams/${id}`, { headers });
  }

  // Get a list of all assessments with Authorization header
  getExams(): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(`${this.apiUrl}/temp-exams`, {
      headers,
    });
  }

  getExamsById(id: number): Observable<any> {
    const headers = this.getAuthHeaders();
    return this.http.get(`${this.apiUrl}/temp-exams/${id}`, {
      headers,
    });
  }

  private getAuthHeaders(): HttpHeaders {
    const token =
      localStorage.getItem("access_token") ||
      localStorage.getItem("refresh_token");
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return headers;
  }


  public getMyAss() {
    return this.restangular.one("getMyAss");
  }

  public createAssDetail() {
    return this.restangular.all("createAssDetail");
  }

  public createAssMasterHeader() {
    return this.restangular.all("createAssMasterHeader");
  }


  public getMyAssCorrection() {
    return this.restangular.one("getMyAssCorrection");
  }


  public getAssCorrectionEdit(id) {
    return this.restangular.one("getAssCorrectionEdit/" + id);
  }

  public getAssCorrectionEditRetake(id) {
    return this.restangular.one("getAssCorrectionEditRetake/" + id);
  }


  public getMyAssRetake() {
    return this.restangular.one("getMyAssRetake");
  }




  public getRetakeAssDetails_1(id) {
    return this.restangular.one("getRetakeAssDetails_1/" + id);
  }

  public getMyAssCorrectionRetake() {
    return this.restangular.one("getMyAssCorrectionRetake");
  }





  public getObjectiveCorrection(id) {
    return this.restangular.one("getObjectiveCorrection/" + id);
  }




}



// WEBPACK FOOTER //
// /app/src/app/services/exam.service.ts